import { SWRConfiguration } from 'swr';

import {
  GET_SHORT_ABSENCE_HISTORY_SWR_KEY,
  ShortAbsence,
  getShortAbsenceHistory,
} from '~/data/absences/index';
import { UseSWROutput, useSWR } from '~/hooks/useSWR';

type PropsType = {
  employeeId: number;
  absenceIds: string[];
};

export const useGetShortAbsencesHistory = (
  props: PropsType,
  swrConfig?: SWRConfiguration,
): UseSWROutput<ShortAbsence[]> => {
  const { employeeId, absenceIds } = props;

  return useSWR(
    absenceIds.length > 0
      ? [GET_SHORT_ABSENCE_HISTORY_SWR_KEY, employeeId, absenceIds]
      : null,
    ([key_, employeeId, absenceIds]) =>
      Promise.all<ShortAbsence[]>(
        absenceIds.map((absenceId: string) =>
          getShortAbsenceHistory(employeeId, absenceId),
        ),
      ).then((results): ShortAbsence[] => results.flat()),
    swrConfig,
  );
};
